import React, { useState } from 'react';
import moment from 'moment';
import { Dropdown, DropdownButton } from 'react-bootstrap';

import useGlobal from '../../../../store';
import { FormControl } from '../../../../facturotopia';
import SearchInput from '../../../../facturotopia/search-input/SearchInput';
import CalendarDatePicker from '../../../../facturotopia/calendar-date-picker/CalendarDatePicker';
import CalendarDateRangePicker from '../../../../facturotopia/calendar-date-range-picker/CalendarDateRangePicker';

const mapState = (store) => {
  return {
    reportes: store.admin.reportes.facturacion.xml_storage,
  };
};

const mapActions = (actions) => {
  return { ...actions.admin.reportes.facturacion.xml_storage };
};

const ReporteFacturacionXmlStorageSearch = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const [date, setDate] = useState(new Date());

  const [range, setRange] = useState('year');

  const { filters } = state.reportes;

  const [index, setIndex] = useState();

  const handleOnKeywordChange = (keyword) => {
    actions.paginate({
      ...filters,
      search: keyword,
      field: index,
    });
  };

  const handleOnSearchClear = () => {
    handleOnKeywordChange('');
  };

  const getFromAndTo = (date, theRange) => {
    let from = '';
    let to = '';

    if (theRange === 'decade') {
      from = moment(date).startOf('year').format('YYYY-MM-DD');
      to = moment(date).endOf('year').format('YYYY-MM-DD');
    } else if (theRange === 'year') {
      from = moment(date).startOf('month').format('YYYY-MM-DD');
      to = moment(date).endOf('month').format('YYYY-MM-DD');
    } else {
      from = moment(date[0]).format('YYYY-MM-DD');
      to = moment(date[1]).format('YYYY-MM-DD');
    }

    return { from, to };
  };

  const { search } = filters;

  const handleOnDateChange = (date) => {
    const { from, to } = getFromAndTo(date, range);

    setDate(date);

    actions.paginate({
      ...filters,
      from: from,
      to: to,
    });
  };

  const handleOnChange = (value) => {
    let date = new Date();

    if (value.range === 'month') {
      date = [moment().subtract(15, 'days').toDate(), new Date()];
    }

    const { from, to } = getFromAndTo(date, value.range);

    actions.updateFilters({
      from: from,
      to: to,
    });

    setRange(value.range);

    setDate(date);
  };

  const handleOnSelectIndex = (name, event) => {
    const { id } = event.target;

    setIndex(id);
  };

  const getOmnisearchLegend = () => {
    let legend = 'Cliente';

    switch (index) {
      case 'razon_social':
        legend = 'Razón Social';
        break;
      case 'nombre_comercial':
        legend = 'Nombre Comercial';
        break;
      case 'rfc':
        legend = 'RFC';
        break;
      case 'email':
        legend = 'Email';
        break;
      default:
        break;
    }

    return legend;
  };

  return (
    <div className="d-flex flex-column flex-sm-row">
      <div className="d-flex flex-column flex-sm-row">
        <FormControl
          type="select"
          label=""
          name="range"
          placeholder=""
          help=""
          value={range}
          options={optionRange}
          onChange={handleOnChange}
        />
        <div className="pr-2 pb-2">
          {range === 'decade' && (
            <CalendarDatePicker
              name="fecha"
              format={range === 'year' ? 'MM/yyyyy' : 'yyyyy'}
              value={date}
              minDetail={range}
              maxDetail={range}
              onDateChange={handleOnDateChange}
            />
          )}

          {range === 'year' && (
            <CalendarDatePicker
              name="fecha"
              format={range === 'year' ? 'MM/yyyyy' : 'yyyyy'}
              value={date}
              minDetail={range}
              maxDetail={range}
              onDateChange={handleOnDateChange}
            />
          )}

          {range === 'month' && (
            <CalendarDateRangePicker
              name="fecha"
              value={date}
              onDateChange={handleOnDateChange}
            />
          )}
        </div>
        <div className="flex-fill search-container">
          <SearchInput
            onKeywordChange={handleOnKeywordChange}
            onClear={handleOnSearchClear}
            value={search}
          >
            <DropdownButton
              variant="outline-secondary"
              title={getOmnisearchLegend()}
              id="search-index"
              onSelect={handleOnSelectIndex}
            >
              <Dropdown.Item id="">Sin filtro</Dropdown.Item>

              <Dropdown.Divider />

              <Dropdown.Item id="razon_social">Razón Social</Dropdown.Item>
              <Dropdown.Item id="nombre_comercial">Nombre Comercial</Dropdown.Item>
              <Dropdown.Item id="rfc">RFC</Dropdown.Item>
              <Dropdown.Item id="email">Email</Dropdown.Item>
            </DropdownButton>
          </SearchInput>
        </div>
      </div>
    </div>
  );
};

const optionRange = [
  {
    label: 'Año',
    value: 'decade',
  },
  {
    label: 'Mes',
    value: 'year',
  },
  {
    label: 'Día',
    value: 'month',
  },
];

export default ReporteFacturacionXmlStorageSearch;
